<template>
  <div v-if="!chartOptionsList.length" class="vh-100 text-center pt-5" ><img src="//www.shmu.sk/img/loading2.gif" /><br />{{ $t('nwp.loading_chart') }}...</div>
  <div v-on:mouseleave="hideTooltips" @mouseleave="" :class="{'ecmwf-chart-eps':true}" v-else>

    <div class="text-center">
      <a href="#!" @click="lTopIsShow = !lTopIsShow">{{ $t('nwp.vysvetlivky') }}</a>
    </div>
    <transition name="slide">
      <div v-if="lTopIsShow" v-html="legenda_top"></div>
    </transition>

    <h3 class="text-center">&nbsp;{{ station_info }}&nbsp;</h3>

    <highcharts ref="highcharts" :class="`chart-`+height+`-ex`+chartOptions.hdivider"
                v-for="(chartOptions, index) in chartOptionsListOnlyActive"
                :key="index + `-ecm-eps-` + chartOptions.id + `-` + chartOptions.name"
                :options="chartOptions"
                :constructor-type="'chart'"
    >
    </highcharts>

    <div class="text-left mt-2">
      <a href="#!" @click="lBottomIsShow = !lBottomIsShow">{{ $t('nwp.legenda') }}</a>
    </div>
    <transition name="slide">
      <div v-if="lBottomIsShow" v-html="legenda_bottom"></div>
    </transition>


  </div>
</template>

<script>

import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Highstock from 'highcharts/modules/stock';
import Accessibility from 'highcharts/modules/accessibility';
import Heatmap from 'highcharts/modules/heatmap';
import {Chart} from 'highcharts-vue';
import myMixin from './mixin';

HighchartsMore(Highcharts);
Highstock(Highcharts);
Accessibility(Highcharts);
Heatmap(Highcharts);

if (window.wn_lang === 'sk') {

  Highcharts.setOptions({
    lang: {
      weekdays: ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
      shortWeekdays: ['Ned', 'Pon', 'Uto', 'Str', 'Štv', 'Pia', 'Sob'],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
      months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
      resetZoom: 'Zrušiť priblíženie'
    },
    global: {
      useUTC: true
    }
  });
} else {
  Highcharts.setOptions({
    lang: {
      weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortWeekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      resetZoom: 'Cancel zoom'
    },
    global: {
      useUTC: true
    }
  });

}


Highcharts.Pointer.prototype.reset = function () {
  return undefined;
};



export default {
  components: {
    highcharts: Chart
  },
  mixins: [myMixin],
  props: [
    'json_data_multi',
    'json_station',
    'json_type',
    'vars',
    'checked_oblacnosti',
    'height',
    'selected_runtime',
    'tz'
  ],
  data: function () {
    return {
      isLoading: true,
      chartOptionsList: [],
      station_info: '',
      smerVetraTotalEns: 0,
      legenda_top: '',
      legenda_bottom: '',
      lTopIsShow: false,
      lBottomIsShow: false,
    }
  },
  computed: {
    json_data() {
      if (this.json_data_multi.length) {
        let f = this.json_data_multi.find(item => item.type === 'ecmwf');
        if (f) {
          this.station_info = f.data.location_name + ' ('+f.data.elevation+'m)';
          return f.data;
        }
      }
      return null;
    },
    chartOptionsListOnlyActive() {
      const _vars = this.vars;
      const self = this;

      if (this.chartOptionsList.length > 0) {
        return this.chartOptionsList.filter((item) => {

          if (!self.vars.includes(item.id)) return false;
          return true;

        });
      }
      return this.chartOptionsList;
    },
    cloudValueKoeficient() {
      if (this.json_data) {
        if (this.json_data.Total_cloud_cover.paramId === 164) {
          return 1;
        }
        if (this.json_data.Total_cloud_cover.paramId === 228164) {
          return 100;
        }
      }

      return 1;
    },
    precipKoeficient() {
      if (this.json_type) {
        if (this.json_type === 'ecmwf') {
          return 1;
        }
        if (this.json_type === 'alaef') {
          return 1;
        }
      }

      return 1;
    }
  },
  watch: {
    json_data(v) {
      this.isLoading = true;
      this.prepareData();
    },
    isLoading(v) {
      this.$emit("isChartLoading", this.isLoading);
    },
    height(v) {
      this.redrawCharts();
    },
    tz(v) {
      const self = this;
      let utc = true;
      if (v !== 'utc') utc = false;
      Highcharts.setOptions({
        global: {
          useUTC: utc
        }
      });
      this.redrawCharts();
      this.$nextTick(function() {
        self.prepareData();
      });
    },
  },
  mounted() {

    let utc = true;
    if (this.tz !== 'utc') utc = false;
    Highcharts.setOptions({
      global: {
        useUTC: utc
      }
    });

    this.legenda_top = document.getElementById('ecmwf-top').innerHTML;
    this.legenda_bottom = document.getElementById('ecmwf-bottom').innerHTML;




  },
  methods: {
    computedTickInterval(name) {
      if (typeof this.json_data[name] !== 'undefined') {
        let rozdiel  = this.json_data[name].data[1][0] - this.json_data[name].data[0][0];
        return rozdiel * 1000;
      }
      return 1 * 60 * 60 * 1000;
    },
    computedCloudValueKoeficient(name) {
      if (typeof this.json_data[name] !== 'undefined') {
        if (this.json_data[name].paramId === 228164) {
          return 100;
        }
      }

      return 1;
    },
    getMaxValue(arr) {
      return Math.max.apply(null, arr);
    },
    getMaxValueFromMultipleArraysSummed(arr1, arr2) {
      let max1 = this.getMaxValue(arr1);
      let max2 = this.getMaxValue(arr2);
      return  this.myRound(max1 + max2, 0);
    },
    getMaxValueFromMultipleArrays(arr1, arr2) {
      let max1 = this.getMaxValue(arr1);
      let max2 = this.getMaxValue(arr2);
      if (max1 > max2) return max1;
      return max2;
    },
    getDailyMinMaxSum(arr, arr_index) {
      let v_min = -9999;
      let v_max = -9999;
      let v_sum = -9999;
      let final_arr = [];
      let cter = 0;
      let prev_dd = null;
      arr.forEach(item => {
        let dt = item[0];
        let v = item[arr_index];

        let dd = parseInt(this.showDateTimeTZ(dt*1000, 'YYYYMMDD'));

        if (prev_dd !== dd) {
          v_min = -9999;
          v_max = -9999;
          v_sum = -9999;
          cter = 0;
        }

        let final_item = final_arr.find(final_item => final_item.dt === dd);
        if (!final_item) {
          final_item = {
            dt: dd,
            min: v_min,
            max: v_max,
            sum: v_sum,
            cter: cter,
          }
          final_arr.push(final_item);
        }

        let hour = parseInt(this.showDateTimeTZ(dt*1000, 'HH'));
        if (hour >= 0 && hour <= 23) {

          cter++;

          if (v_min === -9999) {
            v_min = v;
          } else {
            if (v < v_min) {
              v_min = v;
            }
          }

          if (v_max === -9999) {
            v_max = v;
          } else {
            if (v > v_max) {
              v_max = v;
            }

          }
          if (v_sum === -9999) {
            v_sum = v;
          } else {
            if (v !== null) {
              v_sum += v;
            }
          }

          final_item.min = v_min;
          final_item.max = v_max;
          final_item.sum = v_sum;
          final_item.cter = cter;

        }

        prev_dd = dd;



      });

      return final_arr;

    },

    getDailyMinMaxSumZra(arr, arr_index) {
      let v_min = -9999;
      let v_max = -9999;
      let v_sum = -9999;
      let final_arr = [];
      let cter = 0;
      let prev_dd = null;
      let final_count = false;
      let dd = null;
      // console.log('-----------')
      arr.forEach(item => {
        let dt = item[0];
        let v = item[arr_index];

        let hour = parseInt(this.showDateTimeTZCustom(dt*1000, 'H', true));
        if (hour === 0) {
          final_count = true;
          // dd si nechavam, lebo nulu idem pocitat do tohto
          // console.log('mam nula k', this.showDateTimeTZCustom(dt*1000, 'YYYYMMDD-H', true) )

        } else { // ak uz nie je 0, tak mam novy cas
          dd = parseInt(this.showDateTimeTZ(dt * 1000, 'YYYYMMDD',true));
          // console.log('mam dd', this.showDateTimeTZCustom(dt*1000, 'YYYYMMDD-H', true))
        }

        let final_item = final_arr.find(final_item => final_item.dt === dd);
        if (!final_item) {
          final_item = {
            dt: dd,
            min: v_min,
            max: v_max,
            sum: v_sum,
            cter: cter,
          }
          final_arr.push(final_item);
        }

        // console.log(dt, dd, v);

        cter++;

        if (v_min === -9999) {
          v_min = v;
        } else {
          if (v < v_min) {
            v_min = v;
          }
        }

        if (v_max === -9999) {
          v_max = v;
        } else {
          if (v > v_max) {
            v_max = v;
          }

        }
        if (v_sum === -9999) {
          v_sum = v;
        } else {
          if (v !== null) {
            v_sum += v;
          }
        }

        final_item.min = v_min;
        final_item.max = v_max;
        final_item.sum = v_sum;
        final_item.cter = cter;

        prev_dd = dd;


        if (final_count) {
          v_min = -9999;
          v_max = -9999;
          v_sum = -9999;
          cter = 0;
          final_count = false;
        }


      });

      return final_arr;

    },
    roundToCeilFive(val, num) {
      let final = Math.ceil(val / num) * num;
      if (final === 0) final = 5;
      return final;
    },
    getPressMin(arr) {
      let carr = arr.map(item => item[1]);
      let v =  Math.min.apply(null, carr);
      if (v >= 980) return v-5;
      else return 980;
    },
    getPressMax(arr) {
      let carr = arr.map(item => item[5]);
      let v =  Math.max.apply(null, carr);
      if (v >= 1020) return v+5;
      else return 1020;
    },
    prepareData: function(v) {
      const self = this;

      if (this.json_data && typeof this.json_data.Air_temperature_at_2m !== 'undefined') {

        let runtime_f = self.showDateTimeTZ(self.selected_runtime * 1000, 'DD. MM. YYYY HH:mm');
        if (self.tz === 'utc') {
          runtime_f += ' UTC';
        }
        runtime_f += ' ('+self.json_station.station_name+')';


        this.chartOptionsList = [
          {
            name: 'Air_temperature_at_2m',
            id: 'tvzd',
            hdivider: 1,
            title: { enabled: true,
              //text:''
              // margin: 0,
              text:  self.$t('nwp.teplota_vzduchu') + ' - ' + runtime_f
            },
            subtitle: {
              text:   self.$t('nwp.teplota_redukovana_na_realnu_nadmorsku_vysku_lokality') + ' ('+this.json_data.Air_temperature_at_2m.unit+')',
            },
            tooltip: {
              valueSuffix: this.json_data.Air_temperature_at_2m.unit,
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',

              minorTickInterval: 1,
              minorGridLineWidth: 0,
              minorTickWidth: 1,
              minorTickLength: 5,

              animation:false,
              tickInterval:undefined,
              plotLines: [{ value: 0, color: 'rgba(0, 170, 255, 1)', width:1, zIndex:2}]
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                tickInterval:undefined,

                minorTickInterval: 1,
                minorGridLineWidth: 0,
                minorTickWidth: 1,
                minorTickLength: 5,

              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(255,0,0, 0.5)',
                negativeColor: 'rgba(0,0,255, 0.5)',
                opacity: 0.5,
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false,
                  states: {
                    hover: {
                      enabled: true,
                      fillColor: '#333333',
                      radius: 3,
                      lineColor: '#333333',
                      lineWidth: 4,
                    }
                  }
                },
                data: this.json_data.Air_temperature_at_2m.data.map(item => ([item[0] * 1000, item[1], item[5]]))
              },
              {
                type: 'areasplinerange',
                color: 'rgba(255,0,0, 0.7)',
                opacity: 0.5,
                negativeColor: 'rgba(0,0,255, 0.7)',
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false,
                  states: {
                    hover: {
                      enabled: true,
                      fillColor: '#333333',
                      radius: 3,
                      lineColor: '#333333',
                      lineWidth: 4,
                    }
                  }
                },
                data: this.json_data.Air_temperature_at_2m.data.map(item => ([item[0] * 1000, item[2], item[4]]))
              },
              {
                type: 'spline',
                color: '#ff0000',
                negativeColor: '#0000ff',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Air_temperature_at_2m.data.map(item => ([item[0] * 1000, item[3]])),
                zIndex: 4

              },

            ]
          },
          {
            name: 'Total_cloud_cover',
            id: 'cloud',
            hdivider: 1,
            title: { enabled: true,
              //text:''
              // margin: 0,
              text:  self.$t('nwp.oblacnost') + ' - ' + runtime_f
            },
            subtitle: {
              text: self.$t('nwp.celkova_oblacnost') + ' ('+this.json_data.Total_cloud_cover.unit+')',
            },
            tooltip: {
              valueSuffix: this.json_data.Total_cloud_cover.unit,
              valueDecimals: 0
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:25,
              min:0,
              max:100
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                tickInterval:25,
                min:0,
                max:100
              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(243,204,0, 0.5)',
                opacity: 0.5,
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Total_cloud_cover.data.map(item => ([item[0] * 1000, item[1] * this.cloudValueKoeficient, item[5] * this.cloudValueKoeficient]))
              },
              {
                type: 'areasplinerange',
                opacity: 0.5,
                color: 'rgba(243,204,0, 0.9)',
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.Total_cloud_cover.data.map(item => ([item[0] * 1000, item[2] * this.cloudValueKoeficient, item[4] * this.cloudValueKoeficient]))
              },

              {
                type: 'spline',
                color: 'rgb(145,115,0)',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Total_cloud_cover.data.map(item => ([item[0] * 1000, item[3] * this.cloudValueKoeficient])),
                zIndex: 4
              },

            ]
          },
          {
            name: 'High_cloud_cover',
            id: 'cloud_partial',
            hdivider: 2,
            title: { enabled: true,
              text: self.$t('nwp.vysoka_nizka_stredna_oblacnost_p') + ' - ' + runtime_f
              // margin: 0,
              // text:  this.json_data.High_cloud_cover.comment + ' ['+this.json_data.High_cloud_cover.unit+']'
            },
            subtitle: { enabled: true, text:'Čiastové oblačnosti', style: { color: 'rgba(255,255,255,0)' } },
            tooltip: {
              valueSuffix: this.json_data.High_cloud_cover.unit,
              valueDecimals: 0
            },
            xAxis: [
              {
                labels: {
                  enabled: false
                }
              }
            ],
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:25,
              min:0,
              max:100
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                tickInterval:25,
                min:0,
                max:100
              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(0,0,255, 0.3)',
                opacity: 0.5,
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.High_cloud_cover.data.map(item => ([item[0] * 1000, item[1] * this.cloudValueKoeficient, item[5] * this.cloudValueKoeficient]))
              },
              {
                type: 'areasplinerange',
                opacity: 0.5,
                color: 'rgba(0,0,255, 0.6)',
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.High_cloud_cover.data.map(item => ([item[0] * 1000, item[2] * this.cloudValueKoeficient, item[4] * this.cloudValueKoeficient]))
              },

              {
                type: 'spline',
                color: '#0000FF',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.High_cloud_cover.data.map(item => ([item[0] * 1000, item[3] * this.cloudValueKoeficient])),
                zIndex: 4
              },

            ]
          },
          {
            name: 'Medium_cloud_cover',
            id: 'cloud_partial',
            hdivider: 3,
            title: { enabled: true,
              text:'',
              // margin: 0,
              // text:  this.json_data.Medium_cloud_cover.comment + ' ['+this.json_data.Medium_cloud_cover.unit+']'
            },            subtitle: { enabled: false, text:'' },
            tooltip: {
              valueSuffix: this.json_data.Medium_cloud_cover.unit,
              valueDecimals: 0
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:25,
              min:0,
              max:100
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                tickInterval:25,
                min:0,
                max:100
              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(110,215,0, 0.6)',
                opacity: 0.5,
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Medium_cloud_cover.data.map(item => ([item[0] * 1000, item[1] * this.cloudValueKoeficient, item[5] * this.cloudValueKoeficient]))
              },
              {
                type: 'areasplinerange',
                opacity: 0.5,
                color: 'rgba(110,215,0, 0.8)',
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.Medium_cloud_cover.data.map(item => ([item[0] * 1000, item[2] * this.cloudValueKoeficient, item[4] * this.cloudValueKoeficient]))
              },

              {
                type: 'spline',
                color: 'rgb(54,108,0)',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Medium_cloud_cover.data.map(item => ([item[0] * 1000, item[3] * this.cloudValueKoeficient])),
                zIndex: 4
              },

            ]
          },
          {
            name: 'Low_cloud_cover',
            id: 'cloud_partial',
            hdivider: 5,
            title: { enabled: true,
              text:''
              // margin: 0,
              // text:  this.json_data.Low_cloud_cover.comment + ' ['+this.json_data.Low_cloud_cover.unit+']'
            },
            subtitle: { enabled: false, text:'' },
            tooltip: {
              valueSuffix: this.json_data.Low_cloud_cover.unit,
              valueDecimals: 0
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:25,
              min:0,
              max:100
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                tickInterval:25,
                min:0,
                max:100
              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(182,0,0, 0.3)',
                opacity: 0.5,
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Low_cloud_cover.data.map(item => ([item[0] * 1000, item[1] * this.cloudValueKoeficient, item[5] * this.cloudValueKoeficient]))
              },
              {
                type: 'areasplinerange',
                opacity: 0.5,
                color: 'rgba(182,0,0, 0.6)',
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.Low_cloud_cover.data.map(item => ([item[0] * 1000, item[2] * this.cloudValueKoeficient, item[4] * this.cloudValueKoeficient]))
              },

              {
                type: 'spline',
                color: 'rgba(182,0,0, 1)',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Low_cloud_cover.data.map(item => ([item[0] * 1000, item[3] * this.cloudValueKoeficient])),
                zIndex: 4
              },

            ]
          },
          {
            name: 'Total_precipitation',
            id: 'precip',
            hdivider: 1,
            title: { enabled: true,
              text:  this.$t('nwp.zrazky') + ' - ' + runtime_f
            },
            subtitle: { useHTML:true, align:'center', text:  '<div style="text-align:center">' + this.$t('nwp.celkove_zrazky_za_poslednych_sest_hodin') + ' (' + this.json_data.Total_precipitation.unit +')</div>',
              style: {
                fontSize: '12px'
              }
            },
            /*
            subtitle: {
              text:  this.json_data.Total_precipitation_in_the_last_6_hours.comment + ' ['+this.json_data.Total_precipitation_in_the_last_6_hours.unit+']'
            },

             */
            tooltip: {
              valueSuffix: this.json_data.Total_precipitation.unit,
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:1,

              minorTickInterval: 0.1,
              minorGridLineWidth: 0,
              minorTickWidth: 1,
              minorTickLength: 5,


              min:0,
              max: self.roundToCeilFive(self.getMaxValue(
                  this.json_data.Total_precipitation.data.map(item => item[5] / this.precipKoeficient),
              ), 5),
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickInterval:1,
                tickWidth: 1,
                tickColor: '#000',

                minorTickInterval: 0.1,
                minorGridLineWidth: 0,
                minorTickWidth: 1,
                minorTickLength: 5,


              }
            ],
            series: [

              {
                type: 'areasplinerange',
                opacity: 0.8,
                color: 'rgb(163,191,242)',
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Total_precipitation.data.map(item => ([item[0] * 1000, item[1] / this.precipKoeficient, item[5] / this.precipKoeficient]))
              },
              {
                type: 'areasplinerange',
                color: 'rgba(84,84,234)',
                opacity: 0.8,
                name: 'Kvartily',
                marker: { enabled: false },
                data: this.json_data.Total_precipitation.data.map(item => ([item[0] * 1000, item[2] / this.precipKoeficient, item[4] / this.precipKoeficient]))
              },


              /*
                            {
                              type: 'candlestick',
                              color: 'rgba(0,0,255, 0.5)',
                              upColor: 'rgba(0,0,255, 0.3)',
                              lineColor: 'rgba(0,0,255, 0.5)',
                              name: this.json_data.Total_precipitation.quantity + ' - Kvartily',
                              marker: { enabled: false },
                              data: this.json_data.Total_precipitation.data.map(item => ([item[0] * 1000, item[2], item[5], item[1], item[4]]))
                            },
                            */
              {
                type: 'spline',
                color: '#0204a2',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Total_precipitation.data.map(item => ([item[0] * 1000, item[3] / this.precipKoeficient]))
              },
            ]
          },
          {
            name: 'Snowfall',
            id: 'snow',
            hdivider: 1,
            title: { enabled: true,
              text:  this.$t('nwp.sneh') + ' - ' + runtime_f
            },
            subtitle: { useHTML:true, align:'center', text:  '<div style="text-align:center">' + this.$t('nwp.celkove_snehove_zrazky_za_poslednych_sest_hodin_vodny_ekvivalent') + ' (' + this.json_data.Snowfall.unit +')</div>',
              style: {
                fontSize: '12px'
              }
            },
            /*
            subtitle: {
              text:  this.json_data.Total_precipitation_in_the_last_6_hours.comment + ' ['+this.json_data.Total_precipitation_in_the_last_6_hours.unit+']'
            },

             */
            tooltip: {
              valueSuffix: this.json_data.Snowfall.unit,
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:1,

              minorTickInterval: 0.1,
              minorGridLineWidth: 0,
              minorTickWidth: 1,
              minorTickLength: 5,


              min:0,
              max: self.roundToCeilFive(self.getMaxValue(
                  this.json_data.Snowfall.data.map(item => item[5] / this.precipKoeficient),
              ), 5),
            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickInterval:1,
                tickColor: '#000',

                minorTickInterval: 0.1,
                minorGridLineWidth: 0,
                minorTickWidth: 1,
                minorTickLength: 5,


              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(100,200,255,0.4)',
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Snowfall.data.map(item => ([item[0] * 1000, item[1] / this.precipKoeficient, item[5] / this.precipKoeficient])),
                zIndex: 2
              },
              {
                type: 'areasplinerange',
                color: 'rgba(100,200,255, 0.7)',
                name: 'Kvartily',
                marker: { enabled: false },
                data: this.json_data.Snowfall.data.map(item => ([item[0] * 1000, item[2] / this.precipKoeficient, item[4] / this.precipKoeficient])),
                zIndex: 2
              },


              {
                type: 'spline',
                color: 'rgb(43,86,112)',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Snowfall.data.map(item => ([item[0] * 1000, item[3] / this.precipKoeficient])),
                zIndex: 2
              },


            ]
          },
          {
            name: 'Mean_sea_level_pressure',
            id: 'press',
            hdivider: 1,
            title: { enabled: true,
              text:  this.$t('nwp.tlak') + ' - ' + runtime_f
            },
            subtitle: {
              text:  this.$t('nwp.tlak_redukovany_na_hladinu_mora') + ' ('+this.json_data.Mean_sea_level_pressure.unit+')'
            },
            tooltip: {
              valueSuffix: this.json_data.Mean_sea_level_pressure.unit,
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:5,
              opposite: false,
              min: self.getPressMin(this.json_data.Mean_sea_level_pressure.data),
              max: self.getPressMax(this.json_data.Mean_sea_level_pressure.data),
              // plotLines: [{ value: 1013.25, label: { text: 'Priemerný atmosférický tlak (1013 hPa)', style:{ opacity:0.5}}, color: 'rgba(0, 170, 255, 1)', width:1, zIndex:20}],

              minorTickInterval: 1,
              minorGridLineWidth: 0,
              minorTickWidth: 1,
              minorTickLength: 5,

            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickInterval:5,
                tickColor: '#000',

                minorTickInterval: 1,
                minorGridLineWidth: 0,
                minorTickWidth: 1,
                minorTickLength: 5,
              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: '#a3bff2',
                opacity: 0.8,
                name: 'Min/Max',
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Mean_sea_level_pressure.data.map(item => ([item[0] * 1000, item[1], item[5]]))
              },
              {
                type: 'areasplinerange',
                color: '#0a2659',
                opacity: 0.8,
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.Mean_sea_level_pressure.data.map(item => ([item[0] * 1000, item[2], item[4]]))
              },

              {
                type: 'spline',
                color: '#cce84a',
                name: this.$t('nwp.median'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Mean_sea_level_pressure.data.map(item => ([item[0] * 1000, item[3]])),
                zIndex: 4
              },

            ]
          },
          {
            name: 'Wind_speed_at_10m',
            id: 'wind',
            hdivider: 1,
            title: { enabled: true,
              text:  this.$t('nwp.rychlost_vetra_a_narazov') + ' - ' + runtime_f
            },
            subtitle: {
              text:this.$t('nwp.rychlost_a_narazy_vetra_vo_vyske_10m_nad_povrchom') + ' ('+this.json_data.Wind_speed_at_10m.unit+')'
            },
            tooltip: {
              valueSuffix: this.json_data.Wind_speed_at_10m.unit,
              valueDecimals: 1
            },
            yAxis: [{
              title: { enabled: false },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#000',
              lineWidth: 1,
              lineColor: '#000',
              animation:false,
              tickInterval:2,

              minorTickInterval: 1,
              minorGridLineWidth: 0,
              minorTickWidth: 1,
              minorTickLength: 5,

            },
              {
                linkedTo:0,
                opposite: true,
                title: { enabled: false },
                lineColor: '#000',
                lineWidth: 1,
                tickWidth: 1,
                tickColor: '#000',
                tickInterval:2,

                minorTickInterval: 1,
                minorGridLineWidth: 0,
                minorTickWidth: 1,
                minorTickLength: 5,
              }
            ],
            series: [
              {
                type: 'areasplinerange',
                color: 'rgba(191,147,19, 0.5)',
                opacity: 0.5,
                name: 'Min/Max - ' + this.$t('nwp.vietor'),
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Wind_speed_at_10m.data.map(item => ([item[0] * 1000, item[1], item[5]])),
                zIndex: 2
              },
              {
                type: 'areasplinerange',
                color: 'rgba(191,147,19, 0.7)',
                opacity: 0.5,
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.Wind_speed_at_10m.data.map(item => ([item[0] * 1000, item[2], item[4]])),
                zIndex: 2
              },
              {
                type: 'spline',
                color: 'rgb(234,134,5)',
                name: this.$t('nwp.median') + ' - ' + this.$t('nwp.vietor'),
                lineWidth: 4,
                showInTooltip: true,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Wind_speed_at_10m.data.map(item => ([item[0] * 1000, item[3]])),
                zIndex: 4
              },
              /*
          {
            type: 'column',
            color: '#7cc203',
            groupPadding: 0,
            pointPadding: 0,
            borderColor: '#6da226',
            name: this.json_data.Wind_gust_in_the_last_6_hours.quantity,
            marker: { enabled: true, symbol: 'circle', radius:2 },
            data: this.json_data.Wind_gust_in_the_last_6_hours.data.map(function(item) {
              let val = item[3];
              if (val <= 8) val = null;
              return ([item[0] * 1000, val]);
            }),
          },
               */
              /*


        {
          type: 'candlestick',
          color: 'rgba(124,194,3, 1)',
          upColor: 'rgba(124,194,3, 0.8)',
          lineColor: 'rgba(124,194,3, 0.8)',
          name: this.json_data.Wind_gust_in_the_last_6_hours.quantity,
          marker: { enabled: false },
          data: this.json_data.Wind_gust_in_the_last_6_hours.data.map(item => ([item[0] * 1000, item[2], item[5], item[1], item[4]]))
        },

             */

              {
                type: 'areasplinerange',
                color: 'rgba(124,194,3, 0.5)',
                opacity: 0.8,
                name: 'Min/Max - ' + this.$t('nwp.narazy'),
                showInTooltip: true,
                marker: { enabled: false },
                data: this.json_data.Wind_gust_at_10m.data.map(item => ([item[0] * 1000, item[1], item[5]])),
                zIndex: 2
              },
              {
                type: 'areasplinerange',
                color: 'rgba(124,194,3, 0.7)',
                opacity: 0.8,
                name: this.$t('nwp.kvartily'),
                marker: { enabled: false },
                data: this.json_data.Wind_gust_at_10m.data.map(item => ([item[0] * 1000, item[2], item[4]])),
                zIndex: 2
              },

              {
                type: 'spline',
                dashStyle: 'Solid',
                color: 'rgb(66,105,1)',
                name: this.$t('nwp.median') + ' - ' + this.$t('nwp.narazy'),
                showInTooltip: true,
                lineWidth: 4,
                marker: { enabled: false, symbol: 'circle', radius:2 },
                data: this.json_data.Wind_gust_at_10m.data.map(item => ([item[0] * 1000, item[3]])),
                zIndex: 4
              },


            ]
          },
          {
            name: 'Wind_direction_at_10m',
            id: 'winddir',
            hdivider: 1,
            title: { enabled: true,
              text:   this.$t('nwp.smer_vetra') + ' - ' + runtime_f
            },
            subtitle: { text: 'x', style: { color: 'rgba(255,255,255,0)'} },
            tooltip: {
              valueSuffix: '',
              valueDecimals: 0
            },
            yAxis: [{
              title: { enabled: false },
              // categories: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'],
              categories: [this.$t('nwp.wdirs.S'), this.$t('nwp.wdirs.SV'), this.$t('nwp.wdirs.V'), this.$t('nwp.wdirs.JV'), this.$t('nwp.wdirs.J'), this.$t('nwp.wdirs.JZ'), this.$t('nwp.wdirs.Z'), this.$t('nwp.wdirs.SZ')],
              reversed: true
            },
              {
                linkedTo:0,
                //categories: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'],
                categories: [this.$t('nwp.wdirs.S'), this.$t('nwp.wdirs.SV'), this.$t('nwp.wdirs.V'), this.$t('nwp.wdirs.JV'), this.$t('nwp.wdirs.J'), this.$t('nwp.wdirs.JZ'), this.$t('nwp.wdirs.Z'), this.$t('nwp.wdirs.SZ')],
                opposite: true,
                title: { enabled: false },
              }
            ],
            colorAxis: {
              min: 0,
              stops: [
                [0, 'rgba(114,87,4,0)'],
                [1, 'rgba(114,87,4,1)']
              ],
            },
            series: [
              {
                type: 'heatmap',
                name: self.$t('nwp.smer_vetra'),
                colsize: 3 * 36e5, // one day
                borderWidth: 0,
                borderRadius: 5,
                showInTooltip: true,
                nullColor: '#ffffff',
                data: this.prepareWinDirHeatmapData(this.json_data.Wind_direction_at_10m.data),
                dataLabels: {
                  enabled: false,
                  color: '#000000'
                },
                pointPadding: 1,
                accessibility: {
                  enabled: false
                },
                states: {
                  hover: {
                    enabled:false,
                    halo: false,
                    lineWidthPlus: 0
                  }
                },
              },
            ],
          },
        ];

        this.addGlobalParameters();





      }

    },
    addGlobalParameters: function() {
      const self = this;

      let temp_sums, zra_sums,zra_min_sums, zra_max_sums, snow_sums, snow_min_sums, snow_max_sums, press_sums, wind_sums, wind_gust_sums;
      if (self.json_data) {
        temp_sums = self.getDailyMinMaxSum(self.json_data.Air_temperature_at_2m.data, 3);
        zra_sums = self.getDailyMinMaxSumZra(self.json_data.Total_precipitation.data, 3);
        zra_min_sums = self.getDailyMinMaxSumZra(self.json_data.Total_precipitation.data, 2);
        zra_max_sums = self.getDailyMinMaxSumZra(self.json_data.Total_precipitation.data, 4);
        snow_sums = self.getDailyMinMaxSumZra(self.json_data.Snowfall.data, 3);
        snow_min_sums = self.getDailyMinMaxSumZra(self.json_data.Snowfall.data, 2);
        snow_max_sums = self.getDailyMinMaxSumZra(self.json_data.Snowfall.data, 4);
        // press_sums = self.getDailyMinMaxSum(self.json_data.Mean_sea_level_pressure.data, 3);
        wind_sums = self.getDailyMinMaxSum(self.json_data.Wind_speed_at_10m.data, 3);
        wind_gust_sums = self.getDailyMinMaxSum(self.json_data.Wind_gust_at_10m.data, 3);
      }

      // console.log(self.getDailyMinMaxSumZra(self.json_data.Total_precipitation.data, 5));

      this.chartOptionsList.forEach(function(v, i) {


        v.credits = false;
        v.chart = {
          zoomType: 'x',
          resetZoomButton: {
            position: {
              x: -10,
              y: 35
            }
          },
          animation:false,
          credits: false,
          events: {
            render: self.chartLoaded,
            load: self.bindHideTooltips
          },
          zooming: {
            mouseWheel: {
              enabled: false
            }
          },
          /*
          scrollablePlotArea: {
            minWidth: 1110
          }
           */
          alignTicks: true,

        };

        v.legend = {
          enabled: false
        };

        v.tooltip.shared = true;
        v.tooltip.shadow = false;
        v.tooltip.useHTML = true;
        v.tooltip.hideDelay = 100;

        v.tooltip.positioner = function (labelWidth, labelHeight, point) {
          return {
            x: (Math.ceil((this.chart.chartWidth - labelWidth) / 50)  * 50) - 80,
            y: 0
          };
        };

        v.tooltip.headerFormat = '';
        v.tooltip.borderWidth = 0;
        v.tooltip.backgroundColor = 'rgba(255,255,255,0.6)';

        if (v.name === 'Wind_direction_at_10m') {
          v.tooltip.formatter = function (e) {
            return self.tooltipHeatmapFormatter(this, v)
          }
        } else {
          v.tooltip.formatter = function (e) {
            return self.tooltipFormatter(this.points, v)
          }
        }

        v.yAxis[0].labels = {style: { fontSize: '13px' }};
        v.yAxis[1].labels = {style: { fontSize: '13px' }};


        v.xAxis = [{
          crosshair: {
            enabled: true,
            width: 10,
          },
          type: 'datetime',
          tickInterval: 6 * 60 * 60 * 1000,
          tickWidth: 2,
          tickLength: 5,
          tickColor: '#000000',
          minorGridLineWidth: 0,
          minorGridLineColor: '#999',
          minorGridLineDashStyle: 'dot',

          // minorTickInterval: 1 * 60 * 60 * 1000,
          minorTickWidth: 1,
          minorTickLength: 3,


          // tickInterval: 2 * 60 * 60 * 1000,
          dateTimeLabelFormats: {
            day: '%a %e',
            month: '%e. %b',
            year: '%b',
            hour: '%H'
          },
          lineColor: '#000',
          lineWidth: 1,

          gridLineWidth: 1,
          gridLineDashStyle: 'Dot',
          gridLineColor: '#999',
          labels:{
            formatter: function () {
              const label = this.axis.defaultLabelFormatter.call(this);
              if (/^[0-9]{2}$/.test(label)) {
                // console.log('ano')
              } else {
                return '<strong>' + label + '</strong>'
              }
              return label;
            },
            style: { fontSize:'14px' },
            rotation: 270, x:0, y:12
          },
          startOnTick: false,
          endOnTick: false,
          minPadding: 0,
          maxPadding: 0,
          plotLines: [],
          events: {
            setExtremes: function(event) {
              self.syncExtremes(this, event);
            }
          },
        }/*, { // Top X axis
          linkedTo: 0,
          type: 'datetime',
          tickInterval: 24 * 3600 * 1000,
          labels: {
            format: '{value:<span style="font-size: 12px; font-weight: normal">%A</span>}',
            align: 'left',
            x: 3,
            y: 8
          },
          opposite: true,
          tickLength: 20,
          gridLineWidth: 1
        }
        */
        ];
        v.plotOptions = {
          spline: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          column: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          areasplinerange: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          columnrange: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          },
          candlestick: {
            connectNulls: false,
            animation: false,
            states: {
              hover: {
                lineWidthPlus: 0
              }
            }
          }
        };
        v.plotOptions.series = {};
        v.plotOptions.series.point = {};


        v.plotOptions.series.point.events = {
          mouseOver: undefined,
          mouseOut: undefined,
        }

        v.plotOptions.series.states = {
          hover: {
            halo: {
              size: 0
            }
          },
          inactive: {
            enabled: false
          }
        };

        // pridaj polnocne plotlines
        let min_dt = self.json_data.Air_temperature_at_2m.data[0][0];
        let max_dt = self.json_data.Air_temperature_at_2m.data[self.json_data.Air_temperature_at_2m.data.length-1][0];

        let is_first = true;
        for (let i = min_dt; i <= max_dt; i=i+(60*60)) {

          let p_x = 5;
          let hour = parseInt(self.showDateTimeTZ(i*1000, 'HH'));
          let hour_utc = parseInt(self.showDateTimeTZCustom(i*1000, 'HH', true));

          if (hour_utc===0) {

            let i_dpp = i - 24 * 60 * 60;
            let dd = parseInt(self.showDateTimeTZ(i_dpp*1000, 'YYYYMMDD'));
            // priprav value na min / max sum
            let mms_txt = '';
            if (v.name === 'Air_temperature_at_2m') {
              let r = temp_sums.find(ii => ii.dt === dd);
              if (r && r.cter > 3) {
                mms_txt = 'max: ' + self.myRound(r.max,1) + ' °C<br>min: ' + self.myRound(r.min,1) + ' °C';
              }
            }
            if (v.name === 'Total_precipitation') {
              let r = zra_sums.find(ii => ii.dt === dd);
              if (r && r.cter > 3) {
                mms_txt = 'sum: ' + self.myRound(r.sum,1) + ' mm';
              }
              // min/max
              let mms_txt_arr = [];
              let r1 = zra_min_sums.find(ii => ii.dt === dd);
              if (r1 && r1.cter > 3) {
                mms_txt_arr.push(self.myRound(r1.sum,1));
              }
              let r2 = zra_max_sums.find(ii => ii.dt === dd);
              if (r2 && r2.cter > 3) {
                mms_txt_arr.push(self.myRound(r2.sum,1));
              }
              if (mms_txt_arr.length) {
                mms_txt += '<br>'+ mms_txt_arr.join(' | ');
              }
            }
            if (v.name === 'Snowfall') {
              let r = snow_sums.find(ii => ii.dt === dd);
              if (r && r.cter > 3) {
                mms_txt = 'sum: ' + self.myRound(r.sum,1) + ' mm';
              }
              // min/max
              let mms_txt_arr = [];
              let r1 = snow_min_sums.find(ii => ii.dt === dd);
              if (r1 && r1.cter > 3) {
                mms_txt_arr.push(self.myRound(r1.sum,1));
              }
              let r2 = snow_max_sums.find(ii => ii.dt === dd);
              if (r2 && r2.cter > 3) {
                mms_txt_arr.push(self.myRound(r2.sum,1));
              }
              if (mms_txt_arr.length) {
                mms_txt += '<br>' + mms_txt_arr.join(' | ');
              }
            }
            /*
            if (v.name === 'Mean_sea_level_pressure') {
              let r = press_sums.find(ii => ii.dt === dd);
              if (r && r.cter > 3) {
                mms_txt = 'min:' + self.myRound(r.min,1) + ' hPa<br>max:' + self.myRound(r.max,1) + ' hPa';
              }
            }

             */
            if (v.name === 'Wind_speed_at_10m') {
              let mms_txt_arr = ['max:'];
              let r = wind_sums.find(ii => ii.dt === dd);
              if (r && r.cter > 3) {
                mms_txt_arr.push(self.$t('nwp.vvietor')+': ' + self.myRound(r.max,1) + ' m/s');
              }

              let r2 = wind_gust_sums.find(ii => ii.dt === dd);
              if (r2 && r2.cter > 3) {
                mms_txt_arr.push(self.$t('nwp.nnarazy')+': ' + self.myRound(r2.max,1) + ' m/s');
              }
              mms_txt = mms_txt_arr.join('<br>');
              p_x = 20;

            }

            if (is_first) {
              mms_txt = '';
            }
            is_first = false;


            v.xAxis[0].plotLines.push({ value: i*1000, color: 'rgba(0, 0, 0, 0.3)', width:0, zIndex: 2,
              label: {
                useHTML: true,
                verticalAlign: 'top',
                align: 'right',
                rotation: 0,
                y: 20,
                x: p_x,
                formatter: function() {
                  return mms_txt;
                  // return 'min:-22.5 °C<br>max:30.8 °C';
                },
                style: {
                  color: 'rgba(0, 0, 0, 0.75)',
                  textAlign: 'right',
                  fontSize: '12px'
                }

              }
            }); // ciara na polnoc
          }

          if (hour === 0) {
            v.xAxis[0].plotLines.push({ value: i*1000, color: 'rgba(0, 0, 0, 0.3)', width:1, zIndex: 2,

            }); // ciara na polnoc
          }

        }

        // pridat vychod zapad slnka
        let ss = self.getSunriseSunset(min_dt, max_dt, self.json_data.lat, self.json_data.lon)
        v.xAxis[0].plotBands = [];
        let prevItem = [];
        ss.forEach(function(item, i) {
          if (i === 0) {
            prevItem = item;
          } else {
            v.xAxis[0].plotBands.push({from: prevItem[1], to: item[0], color: 'rgba(210,210,210,0.3)', zIndex: 1}); // ciara na polnoc
            prevItem = item;
          }
        });


        if (v.name === 'High_cloud_cover' || v.name === 'Medium_cloud_cover') {
          v.xAxis[0].labels.enabled = false;
          v.xAxis[0].tickWidth = 0;
          v.chart.marginBottom = 10;
        }

        if (v.name === 'Low_cloud_cover' || v.name === 'Medium_cloud_cover') {
          v.chart.marginTop = 5;
        }

        if (v.name === 'High_cloud_cover' || v.name === 'Medium_cloud_cover' || v.name === 'High_cloud_cover') {

        }

        if (v.name === 'Wind_speed_at_10m') {
          v.chart.marginTop = 102;
        }

        if (v.name === 'Wind_direction_at_10m') {
          v.chart.type = 'heatmap';
        }


        v.isLastChart = false;
        if (i === self.chartOptionsList.length - 1) {
          v.isLastChart = true;
        }


      });
    },
    prepareWinDirHeatmapData(v) {
      const self = this;
      if (!v.length) return [];
      let arr = [];
      v.forEach(item => {
        // item je jeden den, ten musim rozdrobit na jednotlive smery
        let dt = item[0] * 1000; // cas
        let pocet_stlpcov = item.length - 1; // -1 len prvy he cas a ten do values nedavame
        let totalEns = 0;
        for (let i = 0; i < pocet_stlpcov; i++) { // prejdeme vsetky hodnoty / smery a vytvorime pole
          arr.push([dt, i, item[i+1]]);
          totalEns += item[i+1];
        }
        if (self.smerVetraTotalEns === 0) {
          self.smerVetraTotalEns = totalEns;
        }

      });

      return arr;

    },
    tooltipHeatmapFormatter(item, v) {
      let i,
          result = '';
      const self = this;

      function formatPoint(p) {

        let val = p.point.options.value;
        let key = p.point.options.y;
        if (val === null) return '';
        if (key === null) return '';
        if (key === '') return '';
        if (isNaN(val)) return '';

        let showInTooltip = false;
        if (typeof p.point.series.userOptions.showInTooltip !== 'undefined' &&
            p.point.series.userOptions.showInTooltip === true
        ) {
          showInTooltip = true;
        }

        if (!showInTooltip) {
          return '';
        }

        let categories = [self.$t('nwp.wdirs.S'), self.$t('nwp.wdirs.SV'), self.$t('nwp.wdirs.V'), self.$t('nwp.wdirs.JV'), self.$t('nwp.wdirs.J'), self.$t('nwp.wdirs.JZ'), self.$t('nwp.wdirs.Z'), self.$t('nwp.wdirs.SZ')];
        let smer = categories[key];

        let pp =  Math.round(val / self.smerVetraTotalEns * 100);

        return '<span style="padding-left: 5px; color:' + p.point.color + '">\u25A0</span> ' + p.series.name + ': <b>'+smer+' ('+pp+' %)</b>&nbsp;&nbsp;<br>'
      }

      let dt = self.showDateTimeTZ(item.point.options.x, 'DD. MM. YYYY HH:mm');
      if (self.tz === 'utc') {
        dt += ' UTC';
      }
      // let dt = self.$moment.utc(points[0].x).format('DD.MM.YYYY HH:mm') + ' UTC';
      result = '<b style="padding-bottom: 3px; display: block; font-size: 14px">'+dt + '</b><span style="font-size: 13px">' + formatPoint(item) + '</span>';

      return result;
    },
    tooltipFormatter(points, v) {
      let i,
          result = '';
      const self = this;

      function formatPoint(p) {

        if (p.point.y === null) return '';
        if (p.point.y === '') return '';
        if (isNaN(p.point.y)) return '';

        let v_t = self.myRound(p.point.y, v.tooltip.valueDecimals);
        if (p.point.high) {
          v_t += ' - ' + self.myRound(p.point.high, v.tooltip.valueDecimals);
        }

        let showInTooltip = false;
        if (typeof p.point.series.userOptions.showInTooltip !== 'undefined' &&
            p.point.series.userOptions.showInTooltip === true
        ) {
          showInTooltip = true;
        }

        if (!showInTooltip) {
          return '';
        }

        let sf = v.tooltip.valueSuffix;
        if (
            typeof p.point.series.userOptions.tooltip !== 'undefined' &&
            typeof p.point.series.userOptions.tooltip.valueSuffix !== 'undefined') {
          sf = p.point.series.userOptions.tooltip.valueSuffix;
        }

        if (sf !== '') {
          sf = ' ' + sf;
        }


        return '<span style="padding-left: 5px; color:' + p.point.color + '">\u25A0</span> ' + p.series.name + ': <b>' + v_t + sf +'</b>&nbsp;&nbsp;<br>'
      }

      for (i = 0; i < points.length; i++) {
        result += formatPoint(points[i])
      }
      let dt = self.showDateTimeTZ(points[0].x, 'DD. MM. YYYY HH:mm');
      if (self.tz === 'utc') {
        dt += ' UTC';
      }
      // let dt = self.$moment.utc(points[0].x).format('DD.MM.YYYY HH:mm') + ' UTC';
      result = '<b style="padding-bottom: 3px; display: block; font-size: 14px">'+dt + '</b><span style="font-size: 13px">' + result + '</span>';

      return result;
    },
    getSunriseSunset: function(min_dt, max_dt, lat, lon) {
      let day_sec = 24 * 60 * 60;
      let sunsetSunriseLimits = [];
      for (let d = min_dt - day_sec; d < max_dt + day_sec; d += day_sec) {
        let t = this.$SunCalc.getTimes(new Date(d * 1000), lat, lon);
        sunsetSunriseLimits.push([t.sunrise.getTime(), t.sunset.getTime()]);
      }
      return sunsetSunriseLimits;

    },
    sync: function(vm, event, type) {
      this.$refs.highcharts.forEach(({ chart }) => {

        if (chart === vm.series.chart) return;

        let points = [];
        if (typeof chart !== 'undefined') {
          chart.series.forEach((series) => {
            series.data.forEach((point) => {
              if (point.x === vm.x) {
                if (type === 'over') {
                  point.setState('hover');
                  points.push(point);
                  // chart.tooltip.refresh([point]);
                  // let e = chart.pointer.normalize(event)
                  // chart.xAxis[0].drawCrosshair(e, point);
                } else {
                  point.setState();
                  chart.tooltip.hide();
                  chart.xAxis[0].hideCrosshair();
                }
              }
            });

          });

          if (points.length > 0) {
            chart.tooltip.refresh(points);
            let e = chart.pointer.normalize(event)
            chart.xAxis[0].drawCrosshair(e, points[0]);

          }
        }

      });
    },
    syncExtremes: function(vm, e) {

      const shouldShowResetZoom = !(e.min === undefined && e.max === undefined);

      if (e.trigger !== 'syncExtremes') { // Prevent feedback loop
        this.$refs.highcharts.forEach(({ chart }) => {
          if (chart !== vm.series.chart) {
            if (chart.xAxis[0].setExtremes) { // It is null while updating
              chart.xAxis[0].setExtremes(
                  e.min,
                  e.max,
                  undefined,
                  false,
                  { trigger: 'syncExtremes' }
              );
            }
          }

          if (shouldShowResetZoom && !chart.resetZoomButton ) {
            chart.showResetZoom();
          } else if(!shouldShowResetZoom && chart.resetZoomButton) {
            chart.resetZoomButton = chart.resetZoomButton.destroy();
          }

        });
      }
    },
    chartLoaded: function(e) {
      const self = this;
      if (e.target.userOptions.isLastChart === true) {
        self.isLoading = false;
      }
    },
    redrawCharts() {
      const self = this;
      if (self.$refs.highcharts.length) {
        self.$refs.highcharts.forEach((cmp) => {
          cmp.chart.redraw();
        });
      }

      this.$nextTick(function() {
        window.dispatchEvent(new Event('resize'));
      });

    },
    showDateTimeTZ(value, format) {
      let ttz = 'UTC';
      if (this.tz !== 'utc') {
        ttz = Intl.DateTimeFormat().resolvedOptions().timeZone
      }

      let momUTC = this.$moment.utc(value);
      return this.$moment.tz(momUTC.clone(), ttz).format(format);
    },
    showDateTimeTZCustom(value, format, is_utc) {
      let ttz = 'UTC';
      if (!is_utc) {
        ttz = Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      let momUTC = this.$moment.utc(value);
      return this.$moment.tz(momUTC.clone(), ttz).format(format);
    },
    hideTooltips() {
      this.$refs.highcharts.forEach(({ chart }) => {
        if (typeof chart !== 'undefined') {
          chart.series.forEach((series) => {
            series.data.forEach((point) => {
              point.setState('');
              chart.tooltip.hide();
              chart.xAxis[0].hideCrosshair();
            });
          });
        }
      });

    },
    bindHideTooltips(wm){
      wm.target.renderTo.removeEventListener('mouseout', this.hideTooltips);
      wm.target.renderTo.addEventListener('mouseout', this.hideTooltips)
    },




  }

}
</script>

<style lang="scss">

</style>

